import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { FormControl, FormHelperText } from "@mui/material";

export default function AutoComplete(props) {
  const {
    placeholderText,
    id,
    size,
    error,
    required,
    onInputChange,
    value,
    options,
    onChange,
    inputValue
  } = props;

  return (
    <FormControl required={required} {...(error && { error: true })}>
      <Autocomplete
        size={size || "small"}
        disablePortal
        id={id}
        getOptionLabel={(option) =>
          String(option.locationId || option)
        }
        options={options}
        value={value}
        onChange={onChange}
        inputValue={inputValue}
        onInputChange={onInputChange}
        className="autoCompleteStyle"
        renderInput={(params) => (
          <TextField {...params} placeholder={placeholderText} fullWidth error={error} className="dropDownValue locationDropDownValue" />
        )}
      />
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
